import { colorConstants } from 'config/colorConstants';
import _ from 'lodash';
import { formatNumWithKMBAlt } from 'utils/helperMethods';

export const commercialForecastGraphParser = (data: any[], variables: any, config: any) => {
    try {
        const result: any = { data: [], minVal: 0, maxVal: 0, legends: [] };
        const { commercialForecast } = config;
        const graphLegendMapping = commercialForecast?.graphLegendMapping;

        //legends
        variables?.forecast_types?.forEach((type: any, index: number) => {
            const legend = graphLegendMapping?.[`${variables?.data_type}_${type}`];
            if (legend) result.legends.push(legend);
        });

        //data
        data.forEach((item: any, idx: number) => {
            const tempArray: any[] = [];
            variables?.forecast_types?.forEach((type: any, index: number) => {
                const value = item?.values?.[index];
                result.minVal = Math.min(result.minVal, value);
                result.maxVal = Math.max(result.maxVal, value);
                tempArray.push({
                    sales: value,
                    labelSales: value,
                    type: graphLegendMapping?.[`${variables?.data_type}_${type}`]?.label || type,
                    category: item?.attribute_name,
                    color: graphLegendMapping?.[`${variables?.data_type}_${type}`]?.color,
                    disableHover: idx === 0,
                });
            });
            result.data.push(tempArray);
        });

        return result;
    } catch (error) {
        throw error;
    }
};

export const commercialForecastTableParser = (data: any[], appConfig: any) => {
    try {
        const { commercialForecast } = appConfig;
        const result: any[] = [];
        const firstItem = data?.[0] || {};
        Object.keys(firstItem)
            .filter((key) => key !== 'attribute_name')
            .forEach((key) => {
                const itemObj = commercialForecast?.tableKeyLabelMapping?.[key] || { label: key, pre: '', post: '' };
                const tempData: any = {
                    label: itemObj?.label,
                };
                data.forEach((item: any, idx: number) => {
                    tempData[item.attribute_name] = _.isNil(item?.[key])
                        ? ''
                        : itemObj?.pre + formatNumWithKMBAlt(item?.[key], 2, 2) + itemObj?.post;
                });
                result.push(tempData);
            });

        return result;
    } catch (error) {
        throw error;
    }
};
